import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';

class Posicao extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            carteira: {},
            data: moment()
        };
    }

    componentDidMount = async () => {
        await this.atualizarCarteira();
    }

    atualizarCarteira = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/carteira/consolidada/${this.state.data.format('YYYYMMDD')}`);
            this.setState({ carteira: res.data });
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleChangeData = async valor => {
        console.log(valor);
        await this.setState({data: moment(valor, 'YYYY-MM-DD')});
		this.atualizarCarteira();
	}
    
    render() {
        return (
            <div>
                <input
                    type="date"
                    className="form-control"
                    value={this.state.data.format('YYYY-MM-DD')}
                    onChange={evt => this.handleChangeData(evt.target.value)}
                />
                <table className="table">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Quantidade</th>
                            <th>Preço Médio</th>
                            <th>Vlr. Investido</th>
                            <th>Vlr. Atual</th>
                            <th>Rentabilidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.carteira.acoes && this.state.carteira.acoes.lista.map(item => {
                            return (
                                <tr key={item.ativo_id}>
                                    <td>{item.ativo}</td>
                                    <td>{item.qtdCustodia}</td>
                                    <td>{parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.qtdCustodia * item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{(parseFloat(item.percentualTotal) * 100).toFixed(2)}%</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td>{parseFloat(this.state.carteira.acoes && this.state.carteira.acoes.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            
                        </tr>
                    </tbody>
                </table>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Quantidade</th>
                            <th>Preço Médio</th>
                            <th>Vlr. Investido</th>
                            <th>Vlr. Atual</th>
                            <th>Rentabilidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.carteira.fiis && this.state.carteira.fiis.lista.map(item => {
                            return (
                                <tr key={item.ativo_id}>
                                    <td>{item.ativo}</td>
                                    <td>{item.qtdCustodia}</td>
                                    <td>{parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.qtdCustodia * item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{(parseFloat(item.percentualTotal) * 100).toFixed(2)}%</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td>{parseFloat(this.state.carteira.fiis && this.state.carteira.fiis.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            
                        </tr>
                    </tbody>
                </table>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Quantidade</th>
                            <th>Preço Médio</th>
                            <th>Vlr. Investido</th>
                            <th>Vlr. Atual</th>
                            <th>Rentabilidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.carteira.td && this.state.carteira.td.lista.map(item => {
                            return (
                                <tr key={item.ativo_id}>
                                    <td>{item.ativo}</td>
                                    <td>{(parseFloat(item.qtdCustodia) / 100).toFixed(2)}</td>
                                    <td>{parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{(parseFloat(item.qtdCustodia) * parseFloat(item.precoMedio) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{(parseFloat(item.saldo) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{(parseFloat(item.percentualTotal) * 100).toFixed(2)}%</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td>{parseFloat(this.state.carteira.td && this.state.carteira.td.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            
                        </tr>
                    </tbody>
                </table>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Quantidade</th>
                            <th>Vlr. Investido</th>
                            <th>Vlr. Atual</th>
                            <th>Rentabilidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.carteira.rfixa && this.state.carteira.rfixa.lista.map(item => {
                            return (
                                <tr key={item.ativo_id}>
                                    <td>{item.ativo}</td>
                                    <td>{item.qtdCustodia}</td>
                                    <td>{parseFloat(item.valorInvestido).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{parseFloat(item.saldoTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td>{(parseFloat(item.percentualTotal) * 100).toFixed(2)}%</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td>Total: </td>
                            <td>{parseFloat(this.state.carteira.rfixa && this.state.carteira.rfixa.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

Posicao.propTypes = {
    exibirMensagem: PropTypes.func.isRequired,
  };
  
  function mapStateToProps(state) {
    return {
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto)),
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Posicao);


// WEBPACK FOOTER //
// ./src/components/posicao/PosicaoConsolidada.js